export enum DeliveryMethod {
  Own = 'own',
  Edostav = 'edostav',
  Taxi = 'taxi'
}